export default {
  // 统一使用 www 子域,避免跨子域 cookie / 资源问题
  API_BASE_URL: 'https://www.hnda2022.com/prod-api',
  // API_BASE_URL: 'http://localhost:8080',
  IMG_BASE_URL: 'https://www.hnda2022.com'
  // IMG_BASE_URL: 'http://localhost:8080'
}; 